








import Vue from "vue";
import { Component } from "vue-property-decorator";
import ApiFactory from "../../api/ApiFactory";
import { PersonalRelationDto, TitleDto } from "@/api/ClientPortalApiClient";
@Component({})
export default class CbxTitle extends Vue {
  private types: TitleDto[] | null = [];
  public selectedType = new TitleDto();

  public created() {
    this.getAvailableTypes();
  }

  public typeSelected(type: TitleDto) {
    this.$emit("titleSelected", type);
  }

  public setSelected(type: TitleDto | undefined) {
    if (type) {
      this.selectedType = type;
    }
  }

  private getAvailableTypes() {
    const api = ApiFactory.CreateDataClient();
    api
      .title_IndexAll()
      .then(result => {
        if (result) {
          this.types = result;
        } else {
          this.types = [];
        }
      })
      .catch(error => {
        console.log(error);
        this.types = [];
      });
  }
}
